import { useState } from "react";

import useAuth from "../../../hooks/useAuth";
import useLearning from "../../../hooks/useLearning";
import styles from "./SaveIssueBanner.module.css";

/**
 * "We can't save your progress right now."
 *
 * Two failure modes land here, and both used to be silent:
 *
 *  - Signed in, but the profile never loaded (Firestore unreachable, or
 *    no database exists for the project at all).
 *  - Signed in and playing, but a learning write failed part-way through.
 *
 * Either way the user keeps playing (nothing is blocked), but they are
 * told, because letting someone earn an evening's worth of Football IQ
 * that quietly evaporates is worse than admitting the problem.
 */
const SaveIssueBanner = () => {
  const { status, profile, isLocalMode } = useAuth();
  const { saveFailed } = useLearning();
  const [dismissed, setDismissed] = useState(false);

  // Local development mode has its own, more specific banner.
  if (isLocalMode || dismissed || status !== "signed-in") return null;

  const profileMissing = !profile;
  if (!profileMissing && !saveFailed) return null;

  return (
    <div className={styles.SaveIssueBanner} role="status">
      <div className="container d-flex align-items-center gap-2">
        <i className="fa-solid fa-cloud-arrow-up" aria-hidden="true" />
        <p className={styles.text}>
          <strong>We can&rsquo;t save your progress right now.</strong> You can
          keep watching and everything still works, but your Football IQ
          won&rsquo;t be there next time until this is fixed.
        </p>
        <button
          type="button"
          className={styles.dismiss}
          onClick={() => setDismissed(true)}
          aria-label="Hide this notice"
        >
          <i className="fa-solid fa-xmark" aria-hidden="true" />
        </button>
      </div>
    </div>
  );
};

export default SaveIssueBanner;
